import React, { useEffect, useState } from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";
import MarathonRequests from "services/marathon";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import MarathonTicketListTableHeading from "./MarathonTicketLitstTableHeading";
import MarathonTicketListTableItem from "./MarathonTicketListTableItem";
import Pagination from "@material-ui/lab/Pagination";
import { animateScroll as scroll } from "react-scroll";

const MarathonTicketListTable = ({ searchMode, searchInput, eventId }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    marathonTicketList,
    marathonTicketListCurrentPage,
    marathonTicketListTotalPages,
  } = useSelector(({ tests }) => tests);

  useEffect(() => {
    dispatch(MarathonRequests.getMarathonTicketList(eventId, 1, searchInput));
  }, [searchMode, searchInput]);

  const handleChangePagination = (_, value) => {
    if (searchMode) {
      dispatch(
        MarathonRequests.getMarathonTicketList(eventId, value, searchInput)
      );
    } else {
      dispatch(MarathonRequests.getMarathonTicketList(eventId, value));
    }
    scroll.scrollToTop();
  };

  return (
    <div className="Cmt-table-responsive">
      {marathonTicketList &&
        (marathonTicketList.length === 0 ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            paddingTop={"30px"}
            paddingBottom={"20px"}
          >
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <MarathonTicketListTableHeading />
            </TableHead>
            <TableBody>
              {marathonTicketList.map((item) => (
                <MarathonTicketListTableItem
                  user={item.owner}
                  date={item.createdAt}
                  key={item._id}
                  id={item._id}
                  quizId={id}
                />
              ))}
            </TableBody>
          </Table>
        ))}
      {marathonTicketList.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={marathonTicketListTotalPages}
            color="primary"
            page={marathonTicketListCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default MarathonTicketListTable;
